import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_item_ext_RowClass, bl_fi_mst_item_hdr_RowClass, bl_fi_mst_item_line_RowClass} from '../../../dbschema';


export class FinancialItemMarketplaceContainerModel extends BaseContainerModel {
  bl_fi_mst_item_hdr: bl_fi_mst_item_hdr_RowClass = new bl_fi_mst_item_hdr_RowClass();
  bl_fi_mst_item_lines: bl_fi_mst_item_line_RowClass[] = [];
  bl_fi_mst_item_exts: bl_fi_mst_item_ext_RowClass[] = [];
  marketPlace: string[] = [];
}
